import axios from 'axios';

export const refreshPageMixin = {
  data() {
    return {
      currentHash: '24523ab2',
      token: localStorage.getItem('user-token'),
      hashChanged: false,
      newHash: ''
    }
  },
  methods: {
    initVersionCheck(url, frequency = 1000 * 60 * 2) {
      setInterval(async () => {
        await this.checkVersion(url);
      }, frequency);
    },
    async checkVersion(url) {
      try {
        const fileResponse = await axios.create({
          baseURL: process.env.BASE_URL,
        }).get(`appversion.json?t=${new Date().getTime()}`);

        this.newHash = fileResponse.data.hash;

        console.log(`===> current hash: ${this.currentHash} new hash: ${this.newHash}`);

        // this.hashChanged = this.hasHashChanged(this.currentHash, this.newHash);

        if (this.currentHash != this.newHash) {
          this.reloadApp();
        }
      } catch (error) {
        this.loading = false;
      }
    },
    hasHashChanged(currentHash, newHash) {
      const actualHashBuild = '24523ab2';
      console.log(`actual hash build: ${actualHashBuild}`);

      if (!currentHash || currentHash == '24523ab2') {
        return true;
      }

      return currentHash != newHash;
    },
    reloadApp() {
      this.currentHash = this.newHash;
      window.location.reload();
    }
  }
};
